import {  Component,  Input,  OnInit } from '@angular/core';
import { SharedDataService, } from '../../all-services';
import { WindowCloseResult, WindowRef, WindowService, WindowSettings } from '@progress/kendo-angular-dialog';
import { SupplierWorkflowComponent } from '../supplier-workflow/supplier-workflow.component';




@Component({
  selector: 'history-button',
  templateUrl: './history-button.component.html',
  styleUrls: ['./history-button.component.scss']
})
export class HistoryButtonComponent implements OnInit {

  @Input() btnClass?: string = 'btn-xs btn-info';
  @Input() supplierId: number = 0;
  
  public historyWindowOptions: any = {
    width: 1200,
    height: 500,
    top: undefined,
    left: undefined,
    state: 'maximized'
  }

  


  constructor(
    private windowService: WindowService,
    public sharedDataSvc: SharedDataService) { }

  ngOnInit(): void {

  }


  public showWindow() {
    let windowSettings : WindowSettings= new WindowSettings();
    windowSettings.left=this.historyWindowOptions.left;
    windowSettings.top=this.historyWindowOptions.top;
    windowSettings.width=this.historyWindowOptions.width;
    windowSettings.height=this.historyWindowOptions.height;
    windowSettings.state=this.historyWindowOptions.state;
    windowSettings.resizable = true;
    windowSettings.draggable = true;
    windowSettings.appendTo = this.sharedDataSvc.mainContainerRef;
    windowSettings.title="Historique des actions";
    windowSettings.content = SupplierWorkflowComponent;
    const windowRef: WindowRef = this.windowService.open(windowSettings);
    windowRef.result.subscribe((result:WindowCloseResult)=>{
      windowRef.window.destroy();
      
    });
    const workflow: SupplierWorkflowComponent  = windowRef.content.instance;
    workflow.supplierId=this.supplierId;
  }
}
